import Button from "components/library/Button";
import { ArrowUpRightIcon } from "components/library/Icons";
import { HUMANLOOP_DOCS_LINK } from "utils/constants";

export const InteroperabilitySection = () => {
  return (
    <div className="bg-gray-100 dark:bg-black">
      <div className="container-xl relative py-48 md:pt-[84px] md:pb-[80px]">
        <div className="mb-80 space-x-24 text-center md:mx-[64px]">
          <span className="text-16-24 font-bold">
            Plays nice with the tools you love
          </span>
          <Button
            IconRight={ArrowUpRightIcon}
            styling="outline"
            size={24}
            href={HUMANLOOP_DOCS_LINK}
          >
            View docs
          </Button>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-64 gap-y-20">
          <img src="/assets/logos/huggingface.svg" alt="Hugging Face" />
          <img src="/assets/logos/jupyter-logo.svg" alt="Jupyter" />
          <img src="/assets/logos/tensorflow.svg" alt="Tensorflow" />
          <img src="/assets/logos/airflow.svg" alt="Airflow" />
          <img src="/assets/logos/pytorch.svg" alt="PyTorch" />
          <img
            src="/assets/logos/aws.svg"
            className="block h-36 pt-4 opacity-30 grayscale md:hidden"
            alt="AWS"
          />
        </div>
      </div>
    </div>
  );
};
